import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const expirationStatusesAdapter = getAdapter({ idFieldName: 'value' });

const expirationStatusesSlice = createSlice({
  name: 'expirationStatuses',
  initialState: expirationStatusesAdapter.getInitialState(),
  reducers: {
    setExpirationStatuses: (state, { payload: { expirationStatuses } }) => {
      expirationStatusesAdapter.setAll(state, expirationStatuses);
    },
  },
});

const selectors = expirationStatusesAdapter.getSelectors(({ expirationStatuses }) => expirationStatuses);

export const getExpirationStatuses = (state) => selectors.selectAll(state);

export const {
  setExpirationStatuses,
} = expirationStatusesSlice.actions;

export default expirationStatusesSlice.reducer;
